// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var $$String = require("bs-platform/lib/js/string.js");
var Belt_Id = require("bs-platform/lib/js/belt_Id.js");
var Belt_Map = require("bs-platform/lib/js/belt_Map.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.bs.js");
var Match$Blossom = require("re-blossom/src/Match.bs.js");
var Belt_SetString = require("bs-platform/lib/js/belt_SetString.js");
var Caml_primitive = require("bs-platform/lib/js/caml_primitive.js");
var Caml_js_exceptions = require("bs-platform/lib/js/caml_js_exceptions.js");

function make(s) {
  if (s === "") {
    return ;
  } else {
    return s;
  }
}

function toString(x) {
  return x;
}

var cmp = Caml_primitive.caml_string_compare;

function eq(prim, prim$1) {
  return prim === prim$1;
}

var Cmp = Match$Blossom.comparable(cmp);

function cmp$1(param, param$1) {
  var match = Caml_primitive.caml_string_compare(param[0], param$1[0]);
  var match$1 = Caml_primitive.caml_string_compare(param[1], param$1[1]);
  if (match === 0 && match$1 === 0) {
    return 0;
  }
  var e = match + match$1 | 0;
  if (e !== 0) {
    return e;
  } else {
    return match;
  }
}

var Cmp$1 = Belt_Id.MakeComparable({
      cmp: cmp$1
    });

function make$1(i, j) {
  var match = $$String.compare(i, j);
  if (match !== 1) {
    return [
            j,
            i
          ];
  } else {
    return [
            i,
            j
          ];
  }
}

function encode(param) {
  return Json_encode.tuple2((function (prim) {
                return prim;
              }), (function (prim) {
                return prim;
              }), param);
}

function decode(param) {
  return Json_decode.tuple2(Json_decode.string, Json_decode.string, param);
}

function vertices(param) {
  return param.vertices;
}

function encode$1(param) {
  return Json_encode.object_({
              hd: [
                "vertices",
                Json_encode.array((function (prim) {
                        return prim;
                      }), Belt_SetString.toArray(param.vertices))
              ],
              tl: {
                hd: [
                  "edges",
                  Json_encode.array((function (param) {
                          return Json_encode.tuple2(encode, (function (prim) {
                                        return prim;
                                      }), param);
                        }), Belt_Map.toArray(param.edges))
                ],
                tl: /* [] */0
              }
            });
}

function decode$1(json) {
  return {
          vertices: Belt_SetString.fromArray(Json_decode.field("vertices", (function (param) {
                      return Json_decode.array(Json_decode.string, param);
                    }), json)),
          edges: (function (param) {
                return Belt_Map.fromArray(param, Cmp$1);
              })(Json_decode.field("edges", (function (param) {
                      return Json_decode.array((function (param) {
                                    return Json_decode.tuple2(decode, Json_decode.$$float, param);
                                  }), param);
                    }), json))
        };
}

var emptyEdges = Belt_Map.make(Cmp$1);

var empty = {
  vertices: undefined,
  edges: emptyEdges
};

function edgeCount(param) {
  return Belt_Map.size(param.edges);
}

function reducer(graph, action) {
  var edges = graph.edges;
  var vertices = graph.vertices;
  switch (action.TAG | 0) {
    case /* AddVertex */0 :
        return {
                vertices: Belt_SetString.add(vertices, action._0),
                edges: graph.edges
              };
    case /* SetEdge */1 :
        var j = action._1;
        var i = action._0;
        if (i === j) {
          return graph;
        } else {
          return {
                  vertices: Belt_SetString.add(Belt_SetString.add(vertices, i), j),
                  edges: Belt_Map.set(edges, make$1(i, j), action._2)
                };
        }
    case /* RemoveEdge */2 :
        return {
                vertices: vertices,
                edges: Belt_Map.remove(edges, make$1(action._0, action._1))
              };
    case /* RemoveVertex */3 :
        var vertex = action._0;
        return {
                vertices: Belt_SetString.remove(vertices, vertex),
                edges: Belt_Map.keep(edges, (function (param, _w) {
                        if (param[0] !== vertex) {
                          return param[1] !== vertex;
                        } else {
                          return false;
                        }
                      }))
              };
    case /* RenameVertex */4 :
        var new_ = action.new_;
        var old = action.old;
        return {
                vertices: Belt_SetString.add(Belt_SetString.remove(vertices, old), new_),
                edges: Belt_Map.reduce(edges, emptyEdges, (function (newEdges, param, w) {
                        var j = param[1];
                        var i = param[0];
                        if (i === old) {
                          return Belt_Map.set(newEdges, [
                                      new_,
                                      j
                                    ], w);
                        } else if (j === old) {
                          return Belt_Map.set(newEdges, [
                                      i,
                                      new_
                                    ], w);
                        } else {
                          return Belt_Map.set(newEdges, [
                                      i,
                                      j
                                    ], w);
                        }
                      }))
              };
    case /* Set */5 :
        return action._0;
    
  }
}

function fromList(l) {
  var _acc = empty;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (!l$1) {
      return acc;
    }
    var match = l$1.hd;
    _l = l$1.tl;
    _acc = reducer(acc, {
          TAG: /* SetEdge */1,
          _0: match[0],
          _1: match[1],
          _2: match[2]
        });
    continue ;
  };
}

function toList(param) {
  return Belt_Map.reduce(param.edges, /* [] */0, (function (acc, param, w) {
                return {
                        hd: [
                          param[0],
                          param[1],
                          w
                        ],
                        tl: acc
                      };
              }));
}

function verticesToArray(param) {
  return Belt_SetString.toArray(param.vertices);
}

function getEdge(param, i, j) {
  return Belt_Map.get(param.edges, make$1(i, j));
}

var empty$1 = Match$Blossom.make(undefined, /* [] */0, Cmp);

function useMates(cardinalityOpt, graph) {
  var cardinality = cardinalityOpt !== undefined ? cardinalityOpt : /* NotMax */-432534671;
  var match = React.useState(function () {
        return Match$Blossom.make(undefined, toList(graph), Cmp);
      });
  var setMatches = match[1];
  React.useEffect((function () {
          setMatches(function (state) {
                try {
                  return Match$Blossom.make(cardinality, toList(graph), Cmp);
                }
                catch (raw_e){
                  var e = Caml_js_exceptions.internalToOCamlException(raw_e);
                  console.error(e);
                  return state;
                }
              });
          
        }), [
        graph,
        cardinality
      ]);
  return match[0];
}

var Vertex_Cmp = {};

var Vertex_Set = {
  has: Belt_SetString.has
};

var Vertex = {
  make: make,
  toString: toString,
  empty: "",
  eq: eq,
  Cmp: Vertex_Cmp,
  $$Set: Vertex_Set
};

var Mates = {
  empty: empty$1,
  useMates: useMates
};

exports.Vertex = Vertex;
exports.empty = empty;
exports.encode = encode$1;
exports.decode = decode$1;
exports.edgeCount = edgeCount;
exports.vertices = vertices;
exports.reducer = reducer;
exports.toList = toList;
exports.fromList = fromList;
exports.verticesToArray = verticesToArray;
exports.getEdge = getEdge;
exports.Mates = Mates;
/* Cmp Not a pure module */
